(function () {

    /** sign up form service **/
    SUGApp.service('loginservice', ['SUGUtilities', function(util){

        var service = {};

        service.getUserInfo = function( data ){
            return util.APISyncCall( "post", "", data, "m.getMemberInfo", 15000 );
        };

        service.getMainNavigation = function(){
            return util.APISyncCall( "post", "", "", "c.getMainNavigation", 15000 );
        };

        service.resultErrorHandler = function( response ){
    		var Message = "";
    		var result = util.lowerCaseKeys(response);
    		if( angular.isDefined(result.message) ){
    			if( angular.isArray(result.message) ){
                    angular.forEach( result.message, function(obj,key){
                        Message += obj + " ";
                    });
    			} else {
    				Message = result.message;
    			}
    		} else {
    			if( util.isDefinedNotNullNotEmpty(result.statustext) ){
    				Message = result.statustext;
    			} else if( typeof result.status !== undefined && result.status === 0 ){
    				Message = 'Request timeout exceeded. Make sure you are logged in and have an active session.';
    			}
    			else {
    				Message = 'An unknown error occurred while processing your request';
    			}
    		}

    		return Message;
    	};

        return service;

    }]);

})();
